import { ReactNode } from 'react';
import { Box } from '@coolblue-development/becky';
import { Typography } from '@coolblue-development/freddy';
import { Paperclip } from '@coolblue-development/icons';

interface BaseAttachmentChipProps {
  fileName: string;
  trailing?: ReactNode;
  onClick?: () => void;
  dataTestId?: string;
}

const BaseAttachmentChip = ({ fileName, trailing, onClick, dataTestId }: BaseAttachmentChipProps): JSX.Element => {
  const isInteractive = Boolean(onClick);

  return (
    <Box
      onClick={onClick}
      data-testid={dataTestId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minWidth: '250px',
        minHeight: '40px',
        padding: '6px 12px',
        border: '1px solid #DDDDDD',
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        cursor: isInteractive ? 'pointer' : 'default',
        gap: '8px',
        '&:hover': { backgroundColor: isInteractive ? '#F2F7FC' : '#FFFFFF' }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
        <Paperclip color="#868A90" />
        <Box
          component="span"
          sx={{ fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          <Typography color="#666666">{fileName}</Typography>
        </Box>
      </Box>

      {trailing}
    </Box>
  );
};

export default BaseAttachmentChip;
